import React, { useState } from "react";
import "../../assets/css/home-page/product.css";
import productData from "../../components/data/product-data";

export default function Products() {
  // Replace this with your actual business phone number (including country code, without + or spaces)
  const WHATSAPP_NUMBER = "919600544451";

  const INITIAL_PRODUCTS = 3;
  const LOAD_COUNT = 3;

  const [visibleProducts, setVisibleProducts] = useState(INITIAL_PRODUCTS);

  const handleLoadMore = () => {
    setVisibleProducts((prev) =>
      Math.min(prev + LOAD_COUNT, productData.length),
    );
  };

  const handleWhatsAppInquiry = (item) => {
    // Construct a pre-filled professional message
    const message =
      `Hello, I am interested in inquiring about your concrete pipes. Here are the details:\n\n` +
      `• *Product:* ${item.class}\n` +
      `• *Size Requirement:* ${item.size}\n` +
      `• *Listed Price:* ${item.price}\n\n` +
      `Please provide more information regarding availability and logistics.`;

    // Encode text parameters safely for URL transmission
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;

    // Open WhatsApp link in a secure new browser tab
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <section id="products" className="products-section">
      <div className="container-fluid">
        <div className="section-header-block">
          <span className="sub-tag">Structural Portfolio</span>
          <h2 className="main-section-title">Class-Specified RCC Hume Pipes</h2>
          <p className="section-explanation">
            High-grade premium concrete structures cast for industrial
            irrigation, drainage crossways, and heavy municipal utility demands.
          </p>
        </div>

        <div className="products-grid-layout">
          {productData.slice(0, visibleProducts).map((item, idx) => (
            <article key={idx} className="product-technical-card">
              <div className="card-top-accent"></div>

              <div className="product-image-wrapper">
                <img
                  src={item.image}
                  alt={item.class}
                  className="product-card-image"
                  loading="lazy"
                />
              </div>

              <div className="card-content-area">
                <div className="product-rating-stars">
                  {Array.from({ length: 5 }).map((_, starIdx) => (
                    <span
                      key={starIdx}
                      className={`star ${starIdx < item.rating ? "filled" : "empty"}`}
                    >
                      ★
                    </span>
                  ))}
                </div>

                <h3 className="pipe-class-heading">{item.class}</h3>

                <div className="product-commercial-meta">
                  <div className="meta-item">
                    <span className="meta-label">Available Size:</span>
                    <span className="meta-value">{item.size}</span>
                  </div>
                  <div className="meta-item">
                    <span className="meta-label">Price Range:</span>
                    <span className="meta-value price-highlight">
                      {item.price}
                    </span>
                  </div>
                </div>

                <button
                  className="details-inquiry-btn"
                  onClick={() => handleWhatsAppInquiry(item)}
                >
                  Ask For Details
                </button>
              </div>
            </article>
          ))}
        </div>
        {visibleProducts < productData.length && (
          <div className="load-more-wrapper">
            <button className="load-more-btn" onClick={handleLoadMore}>
              Load More Products
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
